import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import { OrdersUIProvider } from './OrdersContextProvider';

const OrdersList = React.lazy(() => import('./Orders'));

function Orders(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست سفارشات</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <OrdersUIProvider>
          <OrdersList {...props} />
        </OrdersUIProvider>
      </Suspense>
    </Page>
  );
}

export default Orders;
